import React from 'react';

const Dashboard = () => {
  return (
    <div className="flex items-center justify-center h-full bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="text-center p-8">
        {/* <h1 className="text-4xl font-bold text-gray-800 mb-4">Welcome to Fluxion Pharmacy</h1>
        <p className="text-lg text-gray-600 mb-8">
          Select a menu item from the left to get started
        </p> */}
        {/* <div className="flex justify-center">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md">
            <p className="text-gray-700">
              Click on any menu item to open it in a new window. You can open multiple windows and manage them using the tabs above.
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;

